import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/')({
  beforeLoad: () => {
    // Redirect /admin to /admin/tenants
    throw redirect({
      to: '/admin/tenants'
    });
  }
});
